// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","app__header":"App_app__header__3Cd2s","app__sidebar":"App_app__sidebar__27FOr","app__body":"App_app__body__255uk"};